import { useEffect } from "react"
import { TournamentClient } from "@/domain/tournament/client/TournamentClient"
import {
  makeInitTournamentListState,
  TournamentListStore,
} from "@/domain/tournament/store/TournamentListStore"

/** 공개 대회 목록 Hook. Page 는 Client 를 직접 호출하지 않는다. */
export function useTournamentList() {
  function useTournamentListState() {
    return TournamentListStore.useStore()
  }

  async function fetchList() {
    try {
      const tournaments = await TournamentClient.getByPaging()
      TournamentListStore.set("tournaments", tournaments)
      TournamentListStore.set("errorMessage", "")
    } catch (error) {
      TournamentListStore.set("tournaments", [])
      TournamentListStore.set(
        "errorMessage",
        error instanceof Error
          ? error.message
          : "대회 목록을 불러오지 못했습니다.",
      )
    } finally {
      TournamentListStore.set("isLoaded", true)
    }
  }

  useEffect(() => {
    TournamentListStore.store.setState(makeInitTournamentListState())
    void fetchList()

    return () => {
      TournamentListStore.store.setState(makeInitTournamentListState())
    }
  }, [])

  return { useTournamentListState }
}
